/**
 * Founder 2026-10-19 — the address behind the record being viewed. The
 * panel shows it in the Key facts Location row, and the top-right Block
 * uses it for bots whose by-name address list is empty (no registered
 * name, e.g. UA `Mozilla/5.0`).
 *
 * Owner / admin / reviewer get the address (the API audit-logs the
 * reveal); everyone else gets null. Fetched once per record.
 */

import { useEffect, useState } from 'react';

import { useOptionalHttp } from '../../api/http-context.js';
import { getRecordAddress } from '../../api/threats.js';

export function useRecordAddress(siteId: string, recordId: string, enabled: boolean): string | null {
  const http = useOptionalHttp();
  const [address, setAddress] = useState<string | null>(null);
  useEffect(() => {
    setAddress(null);
    if (http === null || !enabled) return;
    let live = true;
    void getRecordAddress(http, siteId, recordId)
      .then((r) => { if (live && r.status === 'shown') setAddress(r.address); })
      .catch(() => undefined);
    return () => { live = false; };
  }, [http, siteId, recordId, enabled]);
  return address;
}
